import loadable from '@loadable/component';

// 懒加载组件
const SupplierInvoiceManagement = loadable(() => import('./invoiceManagement/SupplierInvoiceManagement'));
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
// 懒加载组件
const OffSupplierInvoiceManagement = loadable(() => import('./OffInvoiceManagement/SupplierInvoiceManagement'));
const OffInvoiceManagement = loadable(() => import('./OffInvoiceManagement/InvoiceManagement'));
const ImplantableDeliveryManagement = loadable(() => import('./implantableDeliveryManagement/ImplantableDeliveryManagement'));
const ImplantableDeliveryDetailModify = loadable(() => import('./implantableDeliveryManagement/implantableDeliveryDetailModify/ImplantableDeliveryDetailModify'));
const ItemLicenseNewApplication = loadable(() => import('./itemLicenseNewApplication/ItemLicenseNewApplication'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const ItemLicenseNewUpload = loadable(() => import('./itemLicenseNewApplication/ItemLicenseNewUpload'));
const ItemRequestConfirmManagement = loadable(() => import('./itemRequestConfirmManagement/ItemRequestConfirmManagement'));
const ItemUsingDetailQuery = loadable(() => import('./itemUsingDetailQuery/ItemUsingDetailQuery'));
const ItemUdiChangeApplication = loadable(() => import('./itemUdiChangeApplication/ItemUdiChangeApplication'));
const ItemUdiChangeApplicationDetailModify = loadable(() => import('./itemUdiChangeApplication/itemUdiChangeApplicationDetailModify/ItemUdiChangeApplicationDetailModify'));

export const subRoutes = [
  { // 【宁夏】供应商：供应商发票管理
    path: '/SupplierInvoiceManagement',
    component: SupplierInvoiceManagement
  },
  { // 【宁夏】供应商：供应商发票管理明细
    path: '/InvoiceManagement',
    component: InvoiceManagement
  },
  { // 【宁夏】供应商：总务供应商发票管理
    path: '/OffSupplierInvoiceManagement',
    component: OffSupplierInvoiceManagement
  },
  { // 【宁夏】供应商：总务供应商发票管理明细
    path: '/OffInvoiceManagement',
    component: OffInvoiceManagement
  },
  {
    // 801253009 植入性发货单管理
    path: '/ImplantableDeliveryManagement',
    component: ImplantableDeliveryManagement
  },
  {
    // 801253009 植入性发货单管理明细编辑
    path: '/ImplantableDeliveryDetailModify',
    component: ImplantableDeliveryDetailModify
  },
  { // M829251016 【宁夏人民】资质耗材新增申请
    path: '/ItemLicenseNewApplication',
    component: ItemLicenseNewApplication
  },
  { // M829251018 新增耗材资质上传
    path: '/ItemLicenseNewUpload',
    component: ItemLicenseNewUpload
  },
  {
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  { // M829251019 耗材变更确认
    path: '/ItemRequestConfirmManagement',
    component: ItemRequestConfirmManagement
  },
  { // M82254010 【宁夏人民】耗材使用跟踪查询
    path: '/ItemUsingDetailQuery',
    component: ItemUsingDetailQuery
  },
  {
    path: '/ItemUdiChangeApplication',
    component: ItemUdiChangeApplication
  },
  {
    path: '/ItemUdiChangeApplicationDetailModify',
    component: ItemUdiChangeApplicationDetailModify
  }
];
